<div class="loader-container loader-app">
    <div class="spinner">
      <p class="loader-msg">Request is in progress. Please wait for completion.</p>
      <svg width="100px" height="100px" viewBox="0 0 100 100">
            <circle class="circle1" cx="50" cy="50" r="45" />
            <circle class="circle2" cx="50" cy="50" r="45" transform="rotate(-45,50,50)" />
          </svg>
    </div>
  </div>